import React, { useState } from "react";
import { CustomSwitch } from "../../../../Components";
import { useTranslate } from "../../../../Hooks";
import moment from "moment";
import { CheckIcon, CloseXIcon } from "../../../../assets/icons";
import { Box } from "@material-ui/core";

function ActiveSwitch({ data, onChangeHandler, isDarkMode }) {
  const { translate } = useTranslate("NewAgentsRotationCriteria");
  const [isActive, setIsActive] = useState(data.isActive);

  const onChange = () => {
    setIsActive(!isActive);
    onChangeHandler(data, () => setIsActive(!isActive));
  };

  return (
    <>
      <label
        style={{
          fontWeight: 500,
          color: !isDarkMode ? "#475467" : "#94969C",
        }}
      ></label>
      <CustomSwitch
        label={translate("active")}
        name="status"
        size={"md"}
        checked={isActive}
        onChange={onChange}
      />
    </>
  );
}

export const RotationTableData = (
  isDarkMode = false,
  onChangeStatusHandler = () => {}
) => [
  {
    id: 1,
    formFieldId: 1,
    minWidth: 300,
    headerName: "Rotation name",
    field: "label",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "rotationName",
    isDefaultFilterColumn: true,
    fieldKey: "rotationName",
    formFieldTitle: "Rotation name",
    disableColumnMenu: true,
    searchKey: "Rotation name",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          <span style={{ display: "block" }}>{item?.row?.label}</span>
        </label>
      );
    },
  },
  {
    id: 13,
    formFieldId: 13,
    minWidth: 300,
    headerName: "Priority order",
    field: "order",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "priorityOrder",
    isDefaultFilterColumn: true,
    fieldKey: "priorityOrder",
    formFieldTitle: "priorityOrder",
    disableColumnMenu: true,
    searchKey: "priorityOrder",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.order}
        </label>
      );
    },
  },
  {
    id: 2,
    formFieldId: 2,
    minWidth: 300,
    headerName: "Allow bulk leads",
    field: "isBulk",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "bulkLeads",
    isDefaultFilterColumn: true,
    fieldKey: "bulkLeads",
    formFieldTitle: "Allow bulk leads",
    disableColumnMenu: true,
    searchKey: "bulkLeads",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item.row.isBulk ? (
            <CheckIcon fill={"#17B26A"} width="20" height="20" />
          ) : (
            <CloseXIcon width="20" height="20" fill={"#F04438"} />
          )}
        </label>
      );
    },
  },
  {
    id: 4,
    formFieldId: 4,
    minWidth: 300,
    headerName: "Assigned Agents",
    field: "numberOfAgents",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "assignedAgents",
    isDefaultFilterColumn: true,
    fieldKey: "assignedAgents",
    formFieldTitle: "Assigned Agents",
    disableColumnMenu: true,
    searchKey: "Assigned Agents",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.numberOfAgents}
        </label>
      );
    },
  },
  {
    id: 3,
    formFieldId: 3,
    minWidth: 300,
    headerName: "Rotation Status",
    field: "isActive",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "rotationStatus",
    isDefaultFilterColumn: false,
    fieldKey: "rotationStatus",
    formFieldTitle: "Rotation Status",
    disableColumnMenu: true,
    searchKey: "rotationStatus",
    renderCell: (item) => {
      return (
        <ActiveSwitch
          key={item.row.rotationSchemeId}
          data={item.row}
          onChangeHandler={onChangeStatusHandler}
          isDarkMode={isDarkMode}
        />
      );
    },
  },
  {
    id: 5,
    formFieldId: 5,
    minWidth: 300,
    headerName: "Assigned leads (Total)",
    field: "numberOfLeadsAssigned",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "numberOfLeads",
    isDefaultFilterColumn: true,
    fieldKey: "numberOfLeads",
    formFieldTitle: "Assigned leads (Total)",
    disableColumnMenu: true,
    searchKey: "Assigned leads (Total)",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.numberOfLeadsAssigned}
        </label>
      );
    },
  },
  {
    id: 6,
    formFieldId: 6,
    minWidth: 300,
    headerName: "Language",
    field: "languages",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "Language",
    isDefaultFilterColumn: true,
    fieldKey: "languages",
    formFieldTitle: "Language",
    disableColumnMenu: true,
    searchKey: "languages",
    renderCell: (item) => {
      const arr = item?.row?.languages?.map((item) => item.lookupItemName);
      const showNoData = arr.join(", ").length;
      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {showNoData ? arr.join(", ") : "-"}
        </label>
      );
    },
  },
  {
    id: 7,
    formFieldId: 7,
    minWidth: 300,
    headerName: "Country",
    field: "countries",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "Country",
    isDefaultFilterColumn: true,
    fieldKey: "Country",
    formFieldTitle: "Country",
    disableColumnMenu: true,
    searchKey: "Countryx",
    renderCell: (item) => {
      const arr = item?.row?.countries.map((item) => item.lookupItemName);
      const showNoData = arr.join(", ").length;

      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {showNoData ? arr.join(", ") : "-"}
        </label>
      );
    },
  },
  {
    id: 8,
    formFieldId: 8,
    minWidth: 300,
    headerName: "City",
    field: "cities",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "City",
    isDefaultFilterColumn: true,
    fieldKey: "City",
    formFieldTitle: "City",
    disableColumnMenu: true,
    searchKey: "City",
    renderCell: (item) => {
      const arr = item?.row?.cities.map((item) => item.lookupItemName);
      const showNoData = arr.join(", ").length;

      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {showNoData ? arr.join(", ") : "-"}
        </label>
      );
    },
  },
  {
    id: 9,
    formFieldId: 9,
    minWidth: 300,
    headerName: "District",
    field: "districts",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "District",
    isDefaultFilterColumn: true,
    fieldKey: "District",
    formFieldTitle: "District",
    disableColumnMenu: true,
    searchKey: "District",
    renderCell: (item) => {
      const arr = item?.row?.districts.map((item) => item.lookupItemName);
      const showNoData = arr.join(", ").length;

      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {showNoData ? arr.join(", ") : "-"}
        </label>
      );
    },
  },
  {
    id: 10,
    formFieldId: 10,
    minWidth: 300,
    headerName: "Community ",
    field: "communities ",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "Community ",
    isDefaultFilterColumn: true,
    fieldKey: "Community ",
    formFieldTitle: "Community ",
    disableColumnMenu: true,
    searchKey: "Community ",
    renderCell: (item) => {
      const arr = item?.row?.communities.map((item) => item.lookupItemName);
      const showNoData = arr.join(", ").length;

      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {showNoData ? arr.join(", ") : "-"}
        </label>
      );
    },
  },
  {
    id: 11,
    formFieldId: 11,
    minWidth: 300,
    headerName: "Sub-community ",
    field: "subCommunities ",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "Sub-community ",
    isDefaultFilterColumn: true,
    fieldKey: "Sub-community ",
    formFieldTitle: "Sub-community ",
    disableColumnMenu: true,
    searchKey: "Sub-community ",
    renderCell: (item) => {
      const arr = item?.row?.subCommunities.map((item) => item.lookupItemName);
      const showNoData = arr.join(", ").length;

      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {showNoData ? arr.join(", ") : "-"}
        </label>
      );
    },
  },
  {
    id: 12,
    formFieldId: 12,
    minWidth: 300,
    headerName: "Property",
    field: "properties",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "Property",
    isDefaultFilterColumn: true,
    fieldKey: "Property",
    formFieldTitle: "Property",
    disableColumnMenu: true,
    searchKey: "Property",
    renderCell: (item) => {
      const arr = item?.row?.properties.map((item) => item.propertyName);
      const showNoData = arr.join(", ").length;

      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {showNoData ? arr.join(", ") : "-"}
        </label>
      );
    },
  },
  {
    id: 14,
    formFieldId: 14,
    minWidth: 300,
    headerName: "Developer",
    field: "developers",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "Developer",
    isDefaultFilterColumn: true,
    fieldKey: "Developer",
    formFieldTitle: "Developer",
    disableColumnMenu: true,
    searchKey: "Developer",
    renderCell: (item) => {
      const arr = item?.row?.developers.map((item) => item.lookupItemName);
      const showNoData = arr.join(", ").length;

      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {showNoData ? arr.join(", ") : "-"}
        </label>
      );
    },
  },
  {
    id: 15,
    formFieldId: 15,
    minWidth: 300,
    headerName: "Unit Type",
    field: "unitTypes",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "unitType",
    isDefaultFilterColumn: true,
    fieldKey: "unitType",
    formFieldTitle: "Unit Type",
    disableColumnMenu: true,
    searchKey: "unitType",
    renderCell: (item) => {
      const arr = item?.row?.unitTypes.map((item) => item.lookupItemName);
      const showNoData = arr.join(", ").length;

      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {showNoData ? arr.join(", ") : "-"}
        </label>
      );
    },
  },
  //   {
  //     id: 17,
  //     formFieldId: 17,
  //     minWidth: 300,
  //     headerName: "Unit details",
  //     field: "UnitDetails",
  //     sortable: true,
  //     filterable: false,
  //     fieldType: "text",
  //     displayPath: "UnitDetails",
  //     isDefaultFilterColumn: true,
  //     fieldKey: "UnitDetails",
  //     formFieldTitle: "Unit details",
  //     disableColumnMenu: true,
  //     searchKey: "UnitDetails ",
  //     renderCell: (item) => {
  //       return (
  //         <label
  //           style={{
  //             fontWeight: 500,
  //             color: !isDarkMode ? "#101828" : "#F5F5F6",
  //           }}
  //         >
  //           <div>
  //             <UnitSizeIcon width="20" height="20" />
  //             {/* <span>{`${size[0]} - ${size[1]} ft`}</span> */}
  //           </div>
  //           <div>
  //             <BedIcon width="20" height="20" />
  //             {/* <span>{`${bedrooms[0]} - ${bedrooms[1]}`}</span> */}
  //           </div>
  //           <div>
  //             <BathIcon width="20" height="20" />
  //             {/* <span>{`${bathrooms[0]} - ${bathrooms[1]}`}</span> */}
  //           </div>
  //         </label>
  //       );
  //     },
  //   },
  {
    id: 16,
    formFieldId: 16,
    minWidth: 300,
    headerName: "Selling price range",
    field: "priceRange",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "priceRange",
    isDefaultFilterColumn: true,
    fieldKey: "priceRange",
    formFieldTitle: "Selling price range",
    disableColumnMenu: true,
    searchKey: "priceRange ",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {`${item.row.priceRanges.length ? "AED" : ""} ${
            item?.row?.priceRanges?.[0]?.startValue ?? ""
          } - ${item?.row?.priceRanges?.[0]?.endValue ?? ""}`}
        </label>
      );
    },
  },
  {
    id: 18,
    formFieldId: 18,
    minWidth: 300,
    headerName: "Created On",
    field: "creationOn",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "creationOn",
    isDefaultFilterColumn: true,
    fieldKey: "creationOn",
    formFieldTitle: "Created On",
    disableColumnMenu: true,
    searchKey: "creationOn",
    renderCell: (item) => {
      return (
        <Box display={"flex"} flexDirection={"column"}>
          <label
            style={{
              fontWeight: 500,
              color: !isDarkMode ? "#101828" : "#F5F5F6",
            }}
          >
            {moment(item.row.createdOn).format("DD/MMM/YYYY")}
          </label>
          <p style={{ color: !isDarkMode ? "#475467" : "#F5F5F6" }}>
            {item.row.createdBy}
          </p>
        </Box>
      );
    },
  },
  {
    id: 19,
    formFieldId: 19,
    minWidth: 300,
    headerName: "Capacity based on",
    field: "isOverrideLeadCapacitySettingEnabled",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "capacity",
    isDefaultFilterColumn: true,
    fieldKey: "capacity",
    formFieldTitle: "Capacity based on",
    disableColumnMenu: true,
    searchKey: "capacity",
    renderCell: (item) => {
      const agentLimitRule = {
        false: {
          value: "false",
          label: "Overall System",
        },
        true: {
          value: "true",
          label: "Current schema",
        },
      };
      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {agentLimitRule[item.row.isOverrideLeadCapacitySettingEnabled].label}
        </label>
      );
    },
  },
  {
    id: 20,
    formFieldId: 20,
    minWidth: 300,
    headerName: "Distrubution based on",
    field: "rotationSchemeLeadDistributionTypeName",
    sortable: true,
    filterable: false,
    fieldType: "text",
    displayPath: "distrubution",
    isDefaultFilterColumn: true,
    fieldKey: "distrubution",
    formFieldTitle: "Distrubution based on",
    disableColumnMenu: true,
    searchKey: "distrubution",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.rotationSchemeLeadDistributionTypeName}
        </label>
      );
    },
  },
];
